import React from 'react';
import Navbar from '../components/Navbar';
import Gallery from '../components/Gallery';
import Footer from '../components/Footer';

export default function GalleryPage() {
  return (
    <div style={{ background: 'var(--color-bg)' }}>
      <Navbar />
      <div style={{ paddingTop: 90 }}>
        <Gallery />
      </div>
      <Footer />
    </div>
  );
}